import { render } from "./ChatUserList.vue?vue&type=template&id=bdcc442a"
import script from "./ChatUserList.vue?vue&type=script&lang=js"
export * from "./ChatUserList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__